import { css } from '@emotion/react';
import { Colors } from '../../common/Colors';

export const stylesMobile = css`
  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }

  html {
    box-sizing: border-box;

    #app {
      margin: 0 auto;
      min-width: 0;
      max-width: 99rem;
    }

    @keyframes slide-left {
      0% {
        right: -30rem;
      }
      100% {
        right: 0;
      }
    }

    @keyframes slide-right {
      0% {
        right: 0;
      }
      100% {
        right: -30rem;
      }
    }

    @keyframes helloPopup {
      0% {
        bottom: -500px;
      }

      100% {
        bottom: 0;
      }
    }

    @keyframes goodbuyPopup {
      0% {
        bottom: 0;
      }

      100% {
        bottom: -500px;
      }
    }
  }

  body {
    background-color: ${Colors.white};
  }

  #app {
    display: flex;
    flex-direction: column;
    min-width: 100rem;
    min-height: 100%;
  }

  input[type='number'] {
    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      margin: 0;
      -webkit-appearance: none;
    }
  }

  input[type='search'] {
    &::-webkit-search-cancel-button {
      display: none;
    }
  }

  button {
    outline: none;
    cursor: pointer;
    background-color: transparent;
  }
`;
